import React, { useEffect, useState } from "react";
import { doLogin } from "../../../actions/feedActions";
import { connect } from "react-redux";
import {
  getNewTeacher,
  teacherForm,
  teacherFormSubmit,
  teacherProfileUpdate,
} from "../../../actions/tutorFeedActions";
import { fileUpload, getSingleTeacherForms, getToken } from "../../../actions/emActions";
import { Spinner } from "reactstrap";
import UploadVideo from "../../teacherComponents/RecruitmentProcess/UploadVideo";

const RecruitmentForm = (props) => {
  const [introVideoFile, setintroVideoFile] = useState(null);
  const [introVideoPreview, setintroVideoPreview] = useState("");
  const [topicExplainVideoFile, settopicExplainVideoFile] = useState(null);
  const [topicExplainPreview, settopicExplainPreview] = useState("");
  const [teacherInfo, setteacherInfo] = useState("");
  const [loginLoader, setloginLoader] = useState(false);
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [gender, setgender] = useState("");
  const [dob, setdob] = useState("");
  const [year, setyear] = useState("");
  const [month, setmonth] = useState("");
  const [day, setday] = useState("");
  const [number, setnumber] = useState("");
  const [recruitmentId, setrecruitmentId] = useState("");
  const [education, seteducation] = useState("");
  const [experience, setexperience] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [uploadLoader, setuploadLoader] = useState(false);
  const [addedVideo, setaddedVideo] = useState("");
  const [addedVideo2, setaddedVideo2] = useState("");
  const [endpointLoader, setendpointLoader] = useState(false);
  const [snackbarMessage, setsnackbarMessage] = useState("");
  const [snackbarColor, setsnackbarColor] = useState("#01ac8a");
  const [teacherId, setteacherId] = useState("");
  const [snackbar, setsnackbar] = useState();

  const { teacherForm } = props;

  useEffect(() => {
    // setteacherInfo(res2.data);
    // setname( teacher?.user_name);
    // setemail( teacher?.user_email);
    // setnumber( teacher?.lm_candidate_profile[0]["phone"]);
    // setgender( teacher?.lm_candidate_profile[0]["gender"]);
    // setyear( teacher?.lm_candidate_profile?.[0]?.["dob"]?.split("-")?.[0]);
    // setmonth( teacher?.lm_candidate_profile?.[0]?.["dob"]?.split("-")?.[1]);
    // setday( teacher?.lm_candidate_profile?.[0]?.["dob"]?.split("-")?.[2]);
    // setrecruitmentId( id);

    if (teacherForm) {
      const educationData = teacherForm.find((item) => item.question === "Education");
      const experienceData = teacherForm.find((item) => item.question === "Experience");
      const gradesData = teacherForm.find((item) => item.question === "Teaching Grades");
      const introductoryVideoData = teacherForm.find(
        (item) => item.question === "Introductory Video"
      );

      const topicVideoData = teacherForm.find((item) => item.question === "Topic Video");

      if (educationData) {
        seteducation(educationData.answer);
      }

      if (experienceData) {
        setexperience(experienceData.answer);
      }

      if (gradesData) {
        setSelectedSubjects(JSON.parse(gradesData?.answer));
      }

      if (introductoryVideoData) {
        setaddedVideo(introductoryVideoData?.answer);
      }

      if (topicVideoData) {
        setaddedVideo2(topicVideoData?.answer);
      }
      setendpointLoader(false);
    }
  }, []);

  // Event handler for the subject checkboxes
  const handleSubjectChange = (event) => {
    const subject = event.target.value;
    if (selectedSubjects.includes(subject)) {
      setSelectedSubjects(selectedSubjects.filter((item) => item !== subject));
      sendFormFields(
        "Teaching Grades",
        JSON.stringify(selectedSubjects.filter((item) => item !== subject)),
        1
      );
    } else {
      setSelectedSubjects([...selectedSubjects, subject]);
      sendFormFields("Teaching Grades", JSON.stringify([...selectedSubjects, subject]), 1);
    }
  };

  console.log("Subjects", selectedSubjects);

  const handleIntroVideo = (event) => {
    const file = event[0];
    setintroVideoFile(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setintroVideoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleExplanVideo = (event) => {
    const file = event[0];
    settopicExplainVideoFile(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        settopicExplainPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const uploadIntroFunc = () => {
    setuploadLoader(true);
    fileUpload(introVideoFile, teacherId, "tutor")
      .then((res) => {
        sendFormFields("Introductory Video", res?.data[0]?.url, 0);
        setuploadLoader(false);
      })
      .catch((err) => {
        window.alert("Some Error occurred", err);
        setuploadLoader(false);
      });
  };

  const uploadTopicFunc = () => {
    setuploadLoader(true);
    fileUpload(topicExplainVideoFile, teacherId, "tutor")
      .then((res) => {
        sendFormFields("Topic Video", res?.data[0]?.url, 0);
        setuploadLoader(false);
      })
      .catch((err) => {
        window.alert("Some Error occurred", err);
        setuploadLoader(false);
      });
  };

  const sendFormFields = (question, answer, questionType) => {
    // teacherForm(teacherId, recruitmentId, question, answer, questionType).then((res) => {
    //   debugger;
    // });
  };

  useEffect(() => {
    if (education) {
      sendFormFields("Education", education, 0);
    }
  }, [education]);

  useEffect(() => {
    if (experience) {
      sendFormFields("Experience", experience, 0);
    }
  }, [experience]);

  const updateInfoFunc = () => {
    const date = `${year}/${month}/${day}`;

    teacherProfileUpdate(name, email, number, gender, date, teacherId).then((res) => {
      if (res?.status === 201) {
        setsnackbarMessage("Info Updated Successfully");
        setsnackbar(true);
        setTimeout(() => {
          setsnackbar(false);
          setsnackbarColor("#01ac8a");
        }, 2000);
      } else {
        setsnackbarMessage("Error!");
        setsnackbar(true);
        setsnackbarColor("#fb0606");
        setTimeout(() => {
          setsnackbar(false);
        }, 2000);
      }
      debugger;
    });
  };

  const teacherFormSubmitFunc = () => {
    teacherFormSubmit(teacherId, recruitmentId).then((res) => {
      debugger;
      if (res?.status === 201) {
        setsnackbarMessage("Form Submitted Successfully");
        setsnackbar(true);
        setsnackbarColor("#01ac8a");
        setTimeout(() => {
          setsnackbar(false);
        }, 2000);
      } else {
        setsnackbarMessage("Error!");
        setsnackbar(true);
        setsnackbarColor("#fb0606");
        setTimeout(() => {
          setsnackbar(false);
        }, 2000);
      }
    });
  };

  console.log("teacherInfo", teacherInfo);
  return loginLoader ? (
    <div className="text-center">
      <div className="mt-5">
        <label className="font-weight-bold">We are logging you in...</label>
      </div>
      <Spinner size="md" />
    </div>
  ) : (
    <div>
      {endpointLoader ? (
        <div className="text-center mt-3">
          <Spinner size="md" />
        </div>
      ) : (
        <div className="questonsCard">
          <div
            className={snackbar ? "show" : ""}
            id="snackbar"
            style={{ backgroundColor: snackbarColor }}
          >
            {snackbarMessage}
          </div>
          <div>
            <div className="mt-2">
              <h5 className="font-weight-bold">Teaching Information:</h5>
              <hr />
            </div>
            <div className="form-group">
              <label>Education:</label>
              <br />
              <div class="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value={"A level"}
                  checked={education === "A level"}
                  onChange={() => seteducation("A level")}
                />
                <label class="form-check-label" for="exampleRadios1">
                  A level
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="A level"
                  checked={education === "Bachelors"}
                  onChange={() => seteducation("Bachelors")}
                />
                <label class="form-check-label" for="exampleRadios2">
                  Bachelors
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Masters"
                  checked={education === "Masters"}
                  onChange={() => seteducation("Masters")}
                />
                <label class="form-check-label" for="exampleRadios3">
                  Masters
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Others"
                  checked={education === "Others"}
                  onChange={() => seteducation("Others")}
                />
                <label class="form-check-label" for="exampleRadios4">
                  Others
                </label>
              </div>
            </div>
            <div className="form-group">
              <label>Do you have any previous experience in teaching?</label>
              <br />
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value={"No"}
                  checked={experience === "No"}
                  onChange={() => setexperience("No")}
                />
                <label class="form-check-label" for="exampleRadios1">
                  No
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value={"1-2 years"}
                  checked={experience === "1-2 years"}
                  onChange={() => setexperience("1-2 years")}
                />
                <label class="form-check-label" for="exampleRadios2">
                  1-2 years
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value={"3-5 years"}
                  checked={experience === "3-5 years"}
                  onChange={() => setexperience("3-5 years")}
                />
                <label class="form-check-label" for="exampleRadios3">
                  3-5 years
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value={"More than 5 years"}
                  checked={experience === "More than 5 years"}
                  onChange={() => setexperience("More than 5 years")}
                />
                <label class="form-check-label" for="exampleRadios4">
                  More than 5 years
                </label>
              </div>
            </div>
            <div className="form-group">
              <label> Which grade(s) are you comfortable teaching?</label>
              <br />
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Primary"
                  checked={selectedSubjects.includes("Primary")}
                  onChange={handleSubjectChange}
                />
                <label class="form-check-label" for="defaultCheck1">
                  Primary (KG - Grade 5)​​​​​​​​​​​​​​
                </label>
              </div>
              {selectedSubjects.includes("Primary") && (
                <div className="form-group ml-3 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="English (Primary)"
                      checked={selectedSubjects.includes("English (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      English​​​​​​​​​​​​​​
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Math (Primary)"
                      checked={selectedSubjects.includes("Math (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Math​​​​​​​​​​​​​​​​​​​​​
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Science (Primary)"
                      checked={selectedSubjects.includes("Science (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Science
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Creative Writing (Primary)"
                      checked={selectedSubjects.includes("Creative Writing (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Creative Writing
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="AI (Primary)"
                      checked={selectedSubjects.includes("AI (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      AI
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="defaultCheck1"
                      value="Coding (Primary)"
                      checked={selectedSubjects.includes("Coding (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Coding
                    </label>
                  </div>
                </div>
              )}
              <div class="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="Secondary"
                  checked={selectedSubjects.includes("Secondary")}
                  onChange={handleSubjectChange}
                />
                <label class="form-check-label" for="defaultCheck1">
                  Secondary (Grade 6- Grade 11)​​​​​​​​​​​​​​​​​​​​​
                </label>
              </div>
              {selectedSubjects.includes("Secondary") && (
                <div className="form-group ml-3 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="English​​​​​​​​​​ (Secondary)​"
                      checked={selectedSubjects.includes("English​​​​​​​​​​ (Secondary)​")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      English​​​​​​​​​​​​​​
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Math (Secondary)"
                      checked={selectedSubjects.includes("Math (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Math​​​​​​​​​​​​​​​​​​​​​
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Science (Secondary)"
                      checked={selectedSubjects.includes("Science (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Science
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Creative Writing (Secondary)"
                      checked={selectedSubjects.includes("Creative Writing (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="default   Check1">
                      Creative Writing
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="AI (Secondary)"
                      checked={selectedSubjects.includes("AI (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      AI
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Coding (Secondary)"
                      checked={selectedSubjects.includes("Coding (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Coding
                    </label>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-md-6">
                <UploadVideo
                  selectedFile={introVideoFile}
                  setSelectedFile={setintroVideoFile}
                  preview={introVideoPreview}
                  handleFileChange={handleIntroVideo}
                  uploadFunc={uploadIntroFunc}
                  headingText="Introductory Video"
                  loader={uploadLoader}
                  addedVideo={addedVideo}
                />
              </div>
              <div className="col-md-6">
                <UploadVideo
                  selectedFile={topicExplainVideoFile}
                  setSelectedFile={settopicExplainVideoFile}
                  preview={topicExplainPreview}
                  handleFileChange={handleExplanVideo}
                  uploadFunc={uploadTopicFunc}
                  headingText="Topic Explanatory Video"
                  loader={uploadLoader}
                  addedVideo={addedVideo2}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loginSuccessNormal: state.feedRed.loginSuccessNormal,
});

export default connect(mapStateToProps, {
  doLogin,
})(RecruitmentForm);
